import type { FC, ReactNode } from "react";
import { AlertDialog, type AlertDialogVariant } from "./alertDialog.js";
import { CenteredModal } from "./centeredModal.js";

export interface ConfirmationModalProps {
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  title?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: AlertDialogVariant;
  children?: ReactNode;
  onConfirm: () => void;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = (props) => (
  <CenteredModal
    isOpen={props.isOpen}
    onOpenChange={props.onOpenChange}
    isDismissable
  >
    <AlertDialog
      title={props.title || "Unsaved changes"}
      confirmText={props.confirmText || "Discard changes"}
      cancelText={props.cancelText}
      variant={props.variant}
      onConfirm={({ close }) => {
        props.onConfirm();
        close();
      }}
    >
      {props.children || "Your unsaved changes will be discarded."}
    </AlertDialog>
  </CenteredModal>
);
